import DragHandle from '../control/DragHandle'
import Switcher from '../control/Switcher'

const Category = (props) =>
  <div class='tab'>
    <div><DragHandle /> <span>{props.title}</span></div>
    <input type='text' value={props.phrase} onKeyUp={(e) => props.onChange(e.target.value, 'phrase')} />
    <Switcher on={props.enabled} onChange={() => props.onChange(!props.enabled, 'enabled')} />
  </div>

export default Category
